import { __decorate, __metadata } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ApiService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

class AccountPaymentFavoriteDTO {
}

var DeletedEnum;
(function (DeletedEnum) {
    DeletedEnum["FALSE"] = "0";
    DeletedEnum["TRUE"] = "1";
})(DeletedEnum || (DeletedEnum = {}));

var TypeEnum;
(function (TypeEnum) {
    TypeEnum["ON_US"] = "ON_US";
    TypeEnum["TED"] = "TED";
    TypeEnum["BILLET"] = "BILLET";
    TypeEnum["PIX"] = "PIX";
    TypeEnum["TEF"] = "TEF";
})(TypeEnum || (TypeEnum = {}));

const SPE_N_ACCOUNT_FAVORITE = '/spe-n-account-favorite';
let SpeNAccountFavoriteProxy = class SpeNAccountFavoriteProxy {
    constructor(api) {
        this.api = api;
    }
    findAllFavorites(uuidWhiteLabel, uuidAccountPayment) {
        const uri = `${SPE_N_ACCOUNT_FAVORITE}/v1/favorite/white-label/${uuidWhiteLabel}/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    findAllFavoritesType(uuidWhiteLabel, uuidAccountPayment, type) {
        const uri = `${SPE_N_ACCOUNT_FAVORITE}/v1/favorite/white-label/${uuidWhiteLabel}/account-payment/${uuidAccountPayment}/type/${type}`;
        return this.api.get(uri);
    }
    findOneFavorite(uuidWhiteLabel, uuidAccountPayment, uuid) {
        const uri = `${SPE_N_ACCOUNT_FAVORITE}/v1/favorite/white-label/${uuidWhiteLabel}/account-payment/${uuidAccountPayment}/uuid/${uuid}`;
        return this.api.get(uri);
    }
    /**
     * Método retorna os favoritos disponíveis para transferências TED e On-US (Usado para o fluxo no APP)
     * @param uuidWhiteLabel
     * @param uuidAccountPayment
    */
    findFavoritesToTransfer(uuidWhiteLabel, uuidAccountPayment) {
        const uri = `${SPE_N_ACCOUNT_FAVORITE}/v1/favorite/type-transfer/white-label/${uuidWhiteLabel}/account-payment/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    saveFavorite(favorite) {
        const uri = `${SPE_N_ACCOUNT_FAVORITE}/v1/favorite`;
        return this.api.post(uri, favorite);
    }
    updateFavorite(favorite) {
        const uri = `${SPE_N_ACCOUNT_FAVORITE}/v1/favorite`;
        return this.api.put(uri, favorite);
    }
    deleteFavorite(favorite) {
        const uri = `${SPE_N_ACCOUNT_FAVORITE}/v1/favorite/${favorite.uuid}/delete`;
        return this.api.put(uri, {});
    }
};
SpeNAccountFavoriteProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNAccountFavoriteProxy);

let UiPxAccountPaymentFavoriteModule = class UiPxAccountPaymentFavoriteModule {
};
UiPxAccountPaymentFavoriteModule = __decorate([
    NgModule({
        declarations: [],
        providers: [
            SpeNAccountFavoriteProxy
        ],
        imports: [
            UiBsOauthModule
        ]
    })
], UiPxAccountPaymentFavoriteModule);

export { AccountPaymentFavoriteDTO, DeletedEnum, SpeNAccountFavoriteProxy, TypeEnum, UiPxAccountPaymentFavoriteModule };
//# sourceMappingURL=wlp-ui-px-account-payment-favorite.js.map
